<template>
  <div class="m-price-table">
    <a-price-table-header :title="title" />
    <template v-if="list">
      <a-price-table-row
        v-for="(item, key) in list"
        :key="key"
        :title="item.title"
        :subtitle="item.subtitle"
        :price="item.price"
        :unit="item.unit"
        :summary="item.summary"
        :total="item.total"
      />
    </template>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APriceTableHeader from '@/components/atoms/price-table-header/index.vue';
import APriceTableRow from '@/components/atoms/price-table-row/index.vue';

export default {
  name: 'm-price-table',
  components: {
    APriceTableHeader,
    APriceTableRow,
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    list: {
      type: Array,
      default: null,
    },
  },
};
</script>
